<mat-card>
  <h2 translate>refunds.title</h2>
  <span>{{ 'refunds.text' | translate }} </span>
  <form [formGroup]="refundDataForm">
    <mat-grid-list cols="12" rowHeight="90px">
      <mat-grid-tile colspan="4">
        <scf-custom-select-search
          [id]="'establishment'"
          formControlName="establishment"
          fxFlex="100"
          [dataInput]="establishmentsList"
          [placeholder]="'refunds.establishment'"
          [isRequired]="true"
          [hasBlur]="true"
          [showErrors]="refundDataForm?.controls?.establishment?.errors"
          (onBlurTriggered)="getDescription()"
          (selectionChange)="handleSelectionChange($event)"
        >
        </scf-custom-select-search>
      </mat-grid-tile>
      <mat-grid-tile colspan="8"></mat-grid-tile>
      <mat-grid-tile colspan="4">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>refunds.contractNumber</mat-label>
          <input
            id="contractNum"
            formControlName="contractNum"
            matInput
            (blur)="getDescription()"
            (focus)="focusComponentForm()"
            (focusout)="focusOutComponentForm()"
            (keypress)="numberOnly($event)"
            maxlength="7"
            autocomplete="off"
          />
          <mat-error *ngIf="refundDataForm.controls.contractNum.hasError('required')" translate>
            field.required
          </mat-error>
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile colspan="4">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>refunds.authorizationNumber</mat-label>
          <input
            id="authorizationNum"
            formControlName="authorizationNum"
            matInput
            (blur)="getDescription()"
            (focus)="focusComponentForm()"
            (focusout)="focusOutComponentForm()"
            maxlength="11"
            autocomplete="off"
          />
          <mat-error *ngIf="refundDataForm.controls.authorizationNum.hasError('required')" translate>
            field.required
          </mat-error>
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile colspan="4">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>refunds.nifnie</mat-label>
          <input
            id="nifNie"
            formControlName="nifNie"
            matInput
            (blur)="getDescription()"
            (focus)="focusComponentForm()"
            (focusout)="focusOutComponentForm()"
            maxlength="10"
            autocomplete="off"
          />
          <mat-error *ngIf="refundDataForm.controls.nifNie.hasError('required')" translate> field.required </mat-error>
          <mat-error *ngIf="refundDataForm.controls.nifNie.hasError('dniInvalid')" translate>
            field.incorrect
          </mat-error>
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile colspan="4">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>refunds.description</mat-label>
          <input id="refundDescription" formControlName="description" matInput maxlength="20" autocomplete="off" />
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile colspan="4">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>refunds.refundImport</mat-label>
          <input
            id="refundImport"
            formControlName="refundImport"
            matInput
            (keypress)="numberOnly($event)"
            [(ngModel)]="amount"
            (blur)="getFormattedAmount()"
            [(value)]="formattedAmount"
            maxlength="13"
            autocomplete="off"
          />
          <mat-error *ngIf="refundDataForm.controls.refundImport.hasError('required')" translate>
            field.required
          </mat-error>
        </mat-form-field>
      </mat-grid-tile>
    </mat-grid-list>
  </form>
</mat-card>
<div align="end">
  <button id="btnCancel" mat-stroked-button color="accent" class="button-margin" (click)="cancelClick()">
    {{ 'button.cancel' | translate | uppercase }}
  </button>
  <button
    id="btnAccept"
    mat-flat-button
    color="accent"
    class="button-margin"
    (click)="acceptClick()"
    [disabled]="refundDataForm.invalid || isInputFocused"
  >
    {{ 'button.accept' | translate | uppercase }}
  </button>
</div>
